'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var Carousel_module = require('./Carousel.module.css.js');
var leftPath = require('./leftPath.js');
var rightPath = require('./rightPath.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

let ArrowPosition = /*#__PURE__*/function (ArrowPosition) {
  ArrowPosition["ARROW_PREV"] = "prev";
  ArrowPosition["ARROW_NEXT"] = "next";
  return ArrowPosition;
}({});
const DEFAULT_ARROW_FILL_COLOR = '#2C3239';
const SliderArrow = ({
  arrowPosition,
  onClick,
  disabled = true
}) => {
  const isArrowNext = arrowPosition === ArrowPosition.ARROW_NEXT;
  const classes = clsx__default["default"]({
    [Carousel_module["default"].button]: true,
    [Carousel_module["default"].buttonDisabled]: disabled
  });
  const svgClasses = clsx__default["default"]({
    [Carousel_module["default"].arrowSvg]: true,
    [Carousel_module["default"].arrowSvgDisabled]: disabled
  });
  return /*#__PURE__*/React__default["default"].createElement("button", {
    className: classes,
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    className: svgClasses,
    viewBox: "-10 -9 32 32"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: isArrowNext ? rightPath["default"][0] : leftPath["default"][0]
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fill: DEFAULT_ARROW_FILL_COLOR,
    d: isArrowNext ? rightPath["default"][1] : leftPath["default"][1]
  }))));
};

exports.ArrowPosition = ArrowPosition;
exports["default"] = SliderArrow;
